'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { SHARE_URL_TYPE, SURVEY_URL_TYPE, getShareableUrl } from './ShareableUrlBuilder';
var VERSION = 1;
var LEGACY_UUID_IDENTIFIER = '-';

var BYTE_TO_HEX_MAP = _toConsumableArray(Array(256)).map(function (v, i) {
  return (i + 0x100).toString(16).substr(1);
});

var ENCODED_URL_PART_REGEX = /\/([a-z0-9-_]+)([?#].*|\/)?$/i;
var VALID_UUID_CHECK = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/;
var BASE64_URL_SAFE_MAP = [['+', '-'], ['/', '_']];

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  return [BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], '-', BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], '-', BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], '-', BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], '-', BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]], BYTE_TO_HEX_MAP[buf[i++]]].join('');
}

function uuidToBytes(uuid) {
  // Assuming valid UUID
  var bytes = [];
  uuid.replace(/[a-fA-F0-9]{2}/g, function (hex) {
    bytes.push(parseInt(hex, 16));
  });
  return bytes;
}

function arrayBufferToBase64(buffer) {
  var bytes = new Uint8Array(buffer);
  return window.btoa(_toConsumableArray(Array(bytes.byteLength)).reduce(function (t, v, i) {
    return t + String.fromCharCode(bytes[i]);
  }, ''));
}

function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  return new Uint8Array(_toConsumableArray(Array(binaryString.length)).map(function (v, i) {
    return binaryString.charCodeAt(i);
  }));
}

function uuidToB64(uuid) {
  return arrayBufferToBase64(uuidToBytes(uuid));
}

function B64ToUuid(b64) {
  return bytesToUuid(base64ToArrayBuffer(b64));
}

function escapeBase64(b64) {
  return BASE64_URL_SAFE_MAP.reduce(function (t, v) {
    return t.replace(new RegExp("\\" + v[0], 'g'), v[1]);
  }, b64);
}

function unescapeBase64(b64) {
  return BASE64_URL_SAFE_MAP.reduce(function (t, v) {
    return t.replace(new RegExp("\\" + v[1], 'g'), v[0]);
  }, b64);
}

function isValidUuid(token) {
  return VALID_UUID_CHECK.test(token);
}

function getVersionFromSymbol(symbol) {
  return parseInt(symbol, 36) + (isNaN(symbol * 1) && symbol === symbol.toUpperCase() ? 26 : 0);
}

export function getCurrentVersionSymbol() {
  return VERSION < 36 ? VERSION.toString(36) : (VERSION - 26).toString(36).toUpperCase();
}
export function extractShareToken(shareableLink) {
  return ENCODED_URL_PART_REGEX.exec(shareableLink)[1];
}
export function decode(encodedString) {
  var legacyUuid = encodedString.charAt(0) === LEGACY_UUID_IDENTIFIER;
  var offset = legacyUuid ? 2 : 1;
  var formGuid = B64ToUuid(unescapeBase64(encodedString.substring(offset, 22 + offset)));
  return {
    formGuid: legacyUuid ? formGuid.replace(/-/g, '') : formGuid,
    portalId: parseInt(encodedString.substring(22 + offset), 36),
    version: getVersionFromSymbol(encodedString.charAt(offset - 1))
  };
}
export function decodeShareableLink(shareableLink) {
  return decode(extractShareToken(shareableLink));
}
export function encode(formGuid, portalId) {
  return "" + (isValidUuid(formGuid) ? '' : LEGACY_UUID_IDENTIFIER) + getCurrentVersionSymbol() + escapeBase64(uuidToB64(formGuid.replace(/[^a-fA-F0-9]/g, '')).substring(0, 22)) + portalId.toString(36);
}
export function getShareableLink(formGuid, portalId) {
  var isQA = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hublet = arguments.length > 3 ? arguments[3] : undefined;
  return getShareableUrl(SHARE_URL_TYPE, {
    hublet: hublet,
    isQA: isQA
  }) + "/" + encode(formGuid, portalId);
}
export function getSurveyLink(formGuid, portalId) {
  var isQA = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var hublet = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return getShareableUrl(SURVEY_URL_TYPE, {
    hublet: hublet,
    isQA: isQA
  }) + "/" + encode(formGuid, portalId);
}